/**
 * Builds the PUT payload of the admin retailer form.
 *
 * The payload is an explicit allow-list, not a spread of the form values: the retailer GET
 * returns many computed, non-writable fields (health counters, mapping stats...) that must not
 * be sent back. The counterpart is that a field added to the form is silently dropped until it
 * is listed here — which is how ctaLinks was lost on the retailer while it worked on the
 * category and corner forms (#2378).
 */
export default function buildUpdatePayload(values) {
    return {
        name: values.name,
        email: values.email,
        rent: values.rent && parseFloat(values.rent, 10),
        surface: values.surface && parseFloat(values.surface, 10),
        sellers: values.sellers && parseFloat(values.sellers, 10),
        pushActive: values.pushActive,
        sector: values.sector ? values.sector['@id'] : null,
        address: values.address,
        phone: values.phone,
        stockThreshold: values.stockThreshold && parseFloat(values.stockThreshold, 10),
        translations: values.translations,
        clickAndCollectOnly: values.clickAndCollectOnly,
        whatsappPhone: values.whatsappPhone,
        smsPhone: values.smsPhone,
        city: values.city !== '' ? values.city : null,
        commissionRate: values.commissionRate,
        taxRateZero: values.taxRateZero,
        catalogOnly: values.catalogOnly,
        privateProducts: values.privateProducts,
        privatePrices: values.privatePrices,
        hiddenPrices: values.hiddenPrices,
        coniqLocationId: values.coniqLocationId,
        siret: values.siret,
        openingDays: values.openingDays,
        metadata: values.metadata,
        contactName: values.contactName !== '' ? values.contactName : null,
        paymentAccount: values.paymentAccount,
        allowedToSwitchProductParent: values.allowedToSwitchProductParent,
        invoiceShortForm: values.invoiceShortForm ? values.invoiceShortForm : null,
        // null means the feature was never used on this retailer: the Marketplace then omits the
        // field from the Sylius push. An emptied list is sent as [] so Sylius erases the previous
        // value. undefined (form submitted without the section rendered) is dropped by
        // JSON.stringify, leaving the stored value untouched.
        ctaLinks: values.ctaLinks,
    };
}
